export default __webpack_public_path__ + "static/IPhone_App-MockUp-5ec4e9c41320a2bcd6fb038330747b54.png";